import React, { useState } from "react";
import {
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  PolicyOrAccount,
  PolicyStatus,
} from "../../../interfaces/DTO/mislaka_xml_models";
import { formatPolicyStatus } from "../../../utils/enumFormatter";
import { CompoundInterestChart } from "../CompoundInterestChart";
import { colorPolicyStatus } from "../../../utils/colorEnumFormatter";



interface PolicyStatusChipProps {
  policies: PolicyOrAccount[];
  showCount?: boolean;
}

export const PolicyStatusChip: React.FC<PolicyStatusChipProps> = ({
  policies,
  showCount = true,
}) => {
  // const [open, setOpen] = useState(false);
  // const [selectedStatus, setSelectedStatus] = useState<PolicyStatus | null>(
  //   null
  // );

  // חישוב מספר הפוליסות לכל סטטוס
  const groupedStatusCount = policies.reduce(
    (acc: Record<PolicyStatus, number>, policy) => {
      acc[policy.status as PolicyStatus] =
        (acc[policy.status as PolicyStatus] || 0) + 1;
      return acc;
    },
    {} as Record<PolicyStatus, number>
  );

  // פתיחת הדיאלוג
  // const handleChipClick = (status: PolicyStatus) => {
  //   setSelectedStatus(status);
  //   setOpen(true);
  // };

  // // סגירת הדיאלוג
  // const handleClose = () => {
  //   setOpen(false);
  //   setSelectedStatus(null);
  // };

  return (
    <>
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {Object.entries(groupedStatusCount).map(([status, count]) => (
          <Chip
            key={status}
            label={
              showCount
                ? `${formatPolicyStatus(Number(status))} (${count})`
                : `${formatPolicyStatus(Number(status))}`
            }
            sx={{
              backgroundColor: colorPolicyStatus(Number(status)),
              color: "white",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            // onClick={() => handleChipClick(Number(status))}
          />
        ))}
      </div>

      {/* דיאלוג להצגת הגרף */}
      {/* <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>
          חישוב ריבית דריבית
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedStatus !== null && (
            <CompoundInterestChart
              policies={policies}
              selectedStatus={selectedStatus}
            />
          )}
        </DialogContent>
      </Dialog> */}
    </>
  );
};
